import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";
import { Leaf, Loader2 } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Connexion impossible");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-green px-4">
      <form onSubmit={submit} className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-sm" data-testid="admin-login-form">
        <div className="w-12 h-12 rounded-full bg-brand-green text-brand-gold flex items-center justify-center mx-auto mb-4"><Leaf /></div>
        <h1 className="font-serif text-2xl font-bold text-brand-green text-center mb-1">Back-office</h1>
        <p className="text-center text-sm text-brand-green/60 mb-6">Zeitrog</p>
        {error && <div data-testid="login-error" className="bg-brand-alert/10 text-brand-alert text-sm rounded-lg p-3 mb-4">{error}</div>}
        <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className="w-full h-12 rounded-xl border border-brand-green/20 px-4 mb-3 focus:outline-none focus:ring-2 focus:ring-brand-gold" />
        <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Mot de passe" className="w-full h-12 rounded-xl border border-brand-green/20 px-4 mb-5 focus:outline-none focus:ring-2 focus:ring-brand-gold" />
        <button data-testid="login-submit" disabled={loading} className="w-full rounded-full bg-brand-gold text-brand-green py-3 font-bold hover:bg-brand-goldHover flex items-center justify-center gap-2">
          {loading && <Loader2 className="w-4 h-4 animate-spin" />} Se connecter
        </button>
      </form>
    </div>
  );
}
